import React from "react";
import CollectorLoginForm from "./CollectorLogin";
import { useCollectorPwa } from "../../helpers/useCollectorPwa";
import SiteLayout from "../website/site/SiteLayout";
import collectorImg from "../website/assets/images/site/consumer.jpg";
import "./my-collection.scss";

const CollectorLoginPage: React.FC = () => {
  useCollectorPwa();
  return (
    <SiteLayout title="My Collection log in — HastKala Pramanak" minimal minimalLink={{ to: "/collectors", label: "About My Collection" }}>
      <section className="su">
        <div className="s-wrap su__grid">
          <CollectorLoginForm />
          <aside className="su__side" aria-label="What you get">
            <img src={collectorImg} alt="A woman wearing a handwoven Banarasi saree" style={{ objectPosition: "70% center" }} />
            <div className="su__benefits">
              <div><b>$0</b><span>Free to keep and verify your pieces</span></div>
              <div><b>Tap</b><span>Verify any tagged piece — no app needed</span></div>
              <div><b>Private</b><span>What you paid stays visible only to you</span></div>
            </div>
          </aside>
        </div>
      </section>
    </SiteLayout>
  );
};

export default CollectorLoginPage;
